/**
 * Builds a clean query string from params, filtering out falsy values and empty arrays.
 */
export function buildQueryString(params: Record<string, unknown>): string {
  const validParams: Record<string, string> = {};

  for (const key in params) {
    if (!Object.prototype.hasOwnProperty.call(params, key)) continue;

    const value = params[key];

    if (!value && value !== 0 && value !== false) continue;

    if (Array.isArray(value) && value.length === 0) continue;

    if (Array.isArray(value)) {
      const filtered = value.filter((v) => v !== undefined);
      if (filtered.length === 0) continue;
      validParams[key] = filtered.join(",");
    } else {
      validParams[key] = String(value);
    }
  }

  return new URLSearchParams(validParams).toString();
}
